import {Typography, Box} from '@mui/material';
import {CSContext} from 'Context/ContentStackContext';
import {format} from 'date-fns';
import {isDate} from 'date-fns/esm';
import PropTypes from 'prop-types';
import React, {Fragment, useContext} from 'react';
import globalSpacing from 'Theme/Spacing';

const FieldsItem = ({fieldKey, value, csFieldMap}) => {
  const {dateFormat} = useContext(CSContext);
  const fieldValue = fieldKey === 'transactionStatus' ? value || ' ' : value;
  const formatValues = () =>
    fieldKey.includes('Date') && isDate(new Date(value))
      ? format(new Date(value), dateFormat)
      : fieldValue;

  return (
    <Fragment>
      {fieldKey && csFieldMap[fieldKey] && fieldValue && (
        <Box
          sx={{
            flex: '0 0 30%',
            borderBottom: 1,
            marginBottom: globalSpacing.xs,
            paddingTop: globalSpacing.s,
          }}>
          <Typography variant="body2">{csFieldMap[fieldKey]}</Typography>
          <Typography variant="body1" py={globalSpacing.xs}>
            {formatValues()}
          </Typography>
        </Box>
      )}
    </Fragment>
  );
};

FieldsItem.propTypes = {
  fieldKey: PropTypes.string.isRequired,
  value: PropTypes.string,
  csFieldMap: PropTypes.object.isRequired,
};

export default FieldsItem;
